import ActionTypes from './ActionTypes';

const getChatRoom = payload => {
    return {
        type: ActionTypes.GET_CHAT_ROOM,
        payload,
    };
};



const getChatMessages = payload => {
    return {
        type: ActionTypes.GET_CHAT_MESSAGES,
        payload,
    };
};

const updateMessages = payload => {
    return {
        type: ActionTypes.UPDATE_CHAT_MESSAGES,
        payload,
    };
};

const resetChat = () => {
    return {
        type: ActionTypes.RESET_CHAT,
    };
};


const getChatList = payload => {
    return {
        type: ActionTypes.GET_CHAT_LIST,
        payload,
    };
};

const getMessages = payload => {
    return {
        type: ActionTypes.GET_MESSAGES,
        payload,
    };
};


const getVendorMessages = payload => {
    return {
        type: ActionTypes.GET_VENDOR_MESSAGES,
        payload,
    };
};
const getVendorList = payload => {
    return {
        type: ActionTypes.GET_VENDOR_LIST,
        payload,
    };
};
const getGuestList = payload => {
    return {
        type: ActionTypes.GET_GUEST_LIST,
        payload,
    };
};




export { getChatRoom, getChatMessages, updateMessages, resetChat , getChatList , getMessages , getVendorMessages,getVendorList,getGuestList};